import React from "react";
import { LinearProgress, Box } from "@mui/material";

interface DownloadProgressBarProps {
  value: number;
  width?: string;
  height?: number;
  borderRadius?: number;
  backgroundColor?: string;
  progressColor?: string;
  marginBottom?: number;
}

/**
 * Common LinearProgress component for download progress indication
 * @param value - Progress percentage (0-100)
 * @param width - Width of the progress bar (default: "100%")
 * @param height - Height of the progress bar (default: 4)
 * @param borderRadius - Border radius (default: 2)
 * @param backgroundColor - Track color (default: "#e0e0e0")
 * @param progressColor - Progress bar color (default: "#3f51b5")
 * @param marginBottom - Top margin (default: 1)
 */
const DownloadProgressBar: React.FC<DownloadProgressBarProps> = ({
  value,
  width = "100%",
  height = 4,
  borderRadius = 2,
  backgroundColor = "#e0e0e0",
  progressColor = "#3f51b5",
  marginBottom = 1,
}) => {
  return (
    <Box sx={{ width, mb: marginBottom }}>
      <LinearProgress
        variant="determinate"
        value={value}
        sx={{
          height,
          borderRadius,
          backgroundColor, // track color (background)
          "& .MuiLinearProgress-bar": {
            backgroundColor: progressColor, // bar color (progress)
          },
        }}
      />
    </Box>
  );
};

export default DownloadProgressBar;
